export const AUTH_KEYS: OAuth = Object.freeze({
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_ID: 'user_id',
  ACCOUNT_ID: 'account_id',
  MFA_EXCHANGE_TOKEN: 'mfa_exchange_token',
});

interface OAuth {
  ACCESS_TOKEN: string;
  REFRESH_TOKEN: string;
  USER_ID: string;
  ACCOUNT_ID: string;
  MFA_EXCHANGE_TOKEN: string;
}
